import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";

const GetWarehouses=()=>request({
    url: ApiURL.Query.GetWarehouses,
    method: RequestType.GET,
   });
   const GetMusteriIadeUrun=(data:any)=>request({
    url: ApiURL.Query.GetMusteriUrunIade+"?StoreCode="+data.storeCode+"&ReturnId="+data.returnId,
    method: RequestType.GET,
    data:data
   });
   const StoreReturnQuery = {
    GetWarehouses,
    GetMusteriIadeUrun
  };
  
  export default StoreReturnQuery;